var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.0016V8.00161C20.9996 7.65089 20.9071 7.30642 20.7315 7.00277C20.556 6.69913 20.3037 6.44697 20 6.27161L13 2.27161C12.696 2.09607 12.3511 2.00366 12 2.00366C11.6489 2.00366 11.304 2.09607 11 2.27161L4 6.27161C3.69626 6.44697 3.44398 6.69913 3.26846 7.00277C3.09294 7.30642 3.00036 7.65089 3 8.00161V16.0016C3.00036 16.3523 3.09294 16.6968 3.26846 17.0004C3.44398 17.3041 3.69626 17.5562 4 17.7316L11 21.7316C11.304 21.9071 11.6489 21.9996 12 21.9996C12.3511 21.9996 12.696 21.9071 13 21.7316L20 17.7316C20.3037 17.5562 20.556 17.3041 20.7315 17.0004C20.9071 16.6968 20.9996 16.3523 21 16.0016Z",
    stroke: "#FF4E00",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26999 6.96167L12 12.0117L20.73 6.96167",
    stroke: "#FF4E00",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.0817V12.0017",
    stroke: "#FF4E00",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/Materials.c98d42492ed77b784a843933a7d931a4.svg";
export { ForwardRef as ReactComponent };